<template>
  <div class="dashboard-page-cont dashboard-myrfq">
    <span class="model-title">询盘概况</span>
    <div class="new-myrfq-content">
      <div class="new-myrfq-item" v-for="(item,index) in newRfqList" :key="index"
        :style="{
          borderLeft: `1px solid ${item.borderColor}`
        }"
        @click="handleMessageClick(item)"
      >
        <div class="text-content">
          <p class="label">{{item.label}}</p>
          <p class="value">{{countCollect[item.value]}}</p>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="dialogClass"
      :visible.sync="dialogVisible"
      width="390px"
      :before-close="handleClose">
      <div>
        <p class='msg-one'>
          <i class="iconfont icon-icon-xinxijingshi"></i>
          <span>升级会员享有此服务</span>
        </p>
        <p class='msg-two'>如需帮助，请联系您的客服经理</p>
        <div class='msg-three'>
          <div>
            <p>{{$store.state.salesInfoData.userName}}</p>
            <p>客服经理</p>
          </div>
          <p class="msg-message">
            <i class="iconfont icon-icon-shoujihao"></i>
            <span>{{$store.state.salesInfoData.phone}}</span>
          </p>
          <p class="msg-message">
            <i class="iconfont icon-icon-zuojihao"></i>
            <span>{{$store.state.salesInfoData.tel}}</span>
          </p>
          <p class="msg-message">
            <i class="iconfont icon-icon-zuojihaobeifen"></i>
            <span style="color:#066EB7">{{$store.state.salesInfoData.email}}</span>
          </p>
        </div>
      </div>
    </el-dialog>
  </div>  
</template>

<script>
import { getUnReadMessageNum, getOtherNum } from '@/utils/api/dashboard';
import { onlineUrl } from '@/utils/config';

export default {
  data() {
    return {
      onlineUrl,
      countCollect: {
        unReadNum: 0,         //消息待查看
        matchRfqNum: 0,       //匹配询盘
        favoriteRfqNum:0,     //意向询盘
        quotedRfqNum:0,     //已报价询盘
        inviteQuoteNum: 0,    //邀请报价
        pendingAuditNdaRfqNum: 0, //保密协议审核中
        pendingAcceptAwardNum: 0, //授盘待接受
        pendingRatingNum: 0,      //待评价
        // pendingUpdateProgressNum: 0,   生产进度
      },
      dialogVisible: false,
      newRfqList:[
        {
          label:'匹配询盘',
          value:'matchRfqNum',
          linkUrl:`${ onlineUrl }/matched-rfqs/1`,
          id:'1',
          borderColor:'#5864F4'
        },
        {
          label:'意向询盘',
          value:'favoriteRfqNum',
          linkUrl:`${ onlineUrl }/favorite-rfq/list`,
          id:'2',
          borderColor:'#4BD6C2'
        },
        {
          label:'已报价询盘',
          value:'quotedRfqNum',
          linkUrl:`${ onlineUrl }/supplier-query-quoted-and-open-rfqs/1`,
          id:'3',
          borderColor:'#A82DF0'
        },
        {
          label:'邀请报价',
          value:'inviteQuoteNum',
          linkUrl:`${ onlineUrl }/supplier-query-invited-rfqs/1`,
          id:'4',
          borderColor:"#A82DF0"
        },
        {
          label:'保密协议',
          value:'pendingAuditNdaRfqNum',
          linkUrl:`${ onlineUrl }/rfq-nda/list`,
          id:'5',
          borderColor:"#F57012"
        },
        {
          label:'授盘待接受',
          value:'pendingAcceptAwardNum',
          linkUrl:`${ onlineUrl }/supplier-query-awarded-rfqs/1`,
          id:'6',
          borderColor:"#3EC02E"
        },
        {
          label:'待评价',
          value:'pendingRatingNum',
          linkUrl:`${ onlineUrl }/rating/supplier/list-pending-rating/1`,
          id:'7',
          borderColor:"#3C99EF"
        },
      ],

    }
  },
  methods: {
    // 跳转意向询盘
    goFavoriteRfq(url){
      if(this.$store.state.userInfo.leadsStatus==7){
        window.open(url, '_blank')
      }else{
        this.dialogVisible = true;
      }
    },
    // 关闭提示升级会员弹框
    handleClose(){
      this.dialogVisible = false;
    },
    handleMessageClick(item){
      console.log(item,'item')
      if(item.id=='2'){
        this.goFavoriteRfq(item.linkUrl)
        return
      }
      switch (item.id) {
        case '2':
        this.goFavoriteRfq()
        break;
        default:
        window.open(item.linkUrl, '_blank')  
        break;
      }
    },
    getOtherNum() {
      getOtherNum()
        .then(res=> {
            if(res.rspResult.bizCode == 200) {
              this.countCollect = res.data || {}
            }
          })
          .catch(err=> {
            console.error('获取匹配询盘、邀请报价、授盘待接受、生产进度、待评价 的气泡数量失败', err)
          })
    }
  },
  created() {
    this.getOtherNum();
  }
}
</script>

<style lang="scss" scoped>
.dashboard-myrfq {
  background: #fff;
  padding: 20px 15px 20px 20px;
  .myrfq-cont {
    display: flex;
    flex-wrap: wrap;
    .myrfq-item {
      // width: 183px;
      width: calc((100% - 64px) / 4);
      // max-width: 220px;
      height: 82px;
      border-radius: 4px;
      margin-right: 16px;
      margin-bottom: 16px;
      &-link {
        height: 100%;
        box-sizing: border-box;
        display: block;
        padding: 14px 16px;
        background: #F5F7FA;
        &:hover {
          background: #F1F7FA;
        }
      }
      &-icon {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        text-align: center;
        color: #fff;
        margin-bottom: 8px;
        .iconfont {
          line-height: 24px;
          font-size: 12px;
          display: inline-block;
          &.icon-icon-kanban5 {
            margin-left: -1px;
          }
        }

      }
      &-b {
        display: flex;
        align-items: center;
        user-select: none;
        .myrfq-item-label {
          width: max-content;
          margin-right: 10px;
          flex-shrink: 0;
          height: 14px;
          line-height: 14px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181A;
          letter-spacing: 0;
          text-align: justify;
        }
        .myrfq-item-value {
          flex: 1;
          height: 22px;
          font-family: Arial;
          font-weight: Bold;
          font-size: 20px;
          line-height: 22px;
          color: #318CED;
          letter-spacing: 0;
          text-align: right;
        }
      }
      &:nth-last-child(1) {
        margin-right: 0;
      }

      // 处理图标的背景和数量的颜色
      .icon-bg-1 {
        background-image: linear-gradient(155deg, #FF9046 0%, #FF6600 100%);
      }
      .item-value-1 {
        color: #FF7F2A;
      }
      .icon-bg-2 {
        background-image: linear-gradient(155deg, #8992FC 0%, #4956F1 100%);
      }
      .item-value-2 {
        color: #318CED;
      }
      .icon-bg-3 {
        background-image: linear-gradient(155deg, #D264FF 0%, #9B1DEB 100%);
      }
      .item-value-3 {
        color: #A024ED;
      }
      .icon-bg-4 {
        background-image: linear-gradient(155deg, #FF9046 0%, #FF6600 100%);
      }
      .item-value-4 {
        color: #FF7F2A;
      }
      .icon-bg-5 {
        background-image: linear-gradient(155deg, #5BDC5D 0%, #20B820 100%);
      }
      .item-value-5 {
        color: #20B820;
      }
      .icon-bg-6 {
        background-image: linear-gradient(155deg, #5FC0F7 0%, #318CED 100%);
      }
      .item-value-6 {
        color: #318CED;
      }
      .icon-bg-7 {
        background-image: linear-gradient(155deg, #59E5D3 0%, #48D2BE 100%);
      }
      .item-value-7 {
        color: #4BD5C1;
      }

    }
  }
}
::v-deep .dialogClass{
  .el-dialog__body{
    padding: 0 32px 30px;
  }
  .el-dialog__headerbtn{
    top: 31px;
    right: 32px;
  }
  .el-dialog__close{
      font-weight: 600;
  }
  div{
    text-align:center ;
    .msg-one{
      color:#FF6905;
      i{
        font-size: 16px; 
        margin-right: 5px;
      }
      span{
        font-size: 16px;
        font-family: SourceHanSansCN-Medium;
      }
    }
    .msg-two{
      margin:20px 0 20px;
      color: #4F5D78;
      font-family: SourceHanSansCN-Regular;
    }
    .msg-three{
      width: 268px;
      box-shadow: 0 0 6px 0 #066eb71a;
      border-radius: 2px;
      margin:0 auto;
      text-align: left;
      line-height:20px;
      padding:16px;
      background-image:url('~@/assets/image/common/upcard.jpg') ;
      div{
        p{
          text-align: left;
          color: #16181A;
        }
        p:first-child{
          font-weight: 600;
        }
        p:last-child{
          color:#4F5D78;
          font-size:12px;
          line-height: 16px;
          margin-bottom: 17px;
          font-family: SourceHanSansCN-Medium;
        }
      }
      .msg-message{
        line-height: 24px;
        i{
          color: #FF7F2A;
          margin-right:8px;
          font-size: 12px;
        }
        span{
          color: #16181A;
        }
      }

    }
  }
}

//优化过的样式
.new-myrfq-content{
  display: grid;
  grid-template-columns: repeat(4,1fr);
  gap: 16px;
  font-family: SourceHanSansCN-Regular;
  .new-myrfq-item{
    height: 74px;
    flex-shrink: 0;
    border-radius: 8px;
    border-left: 1px solid #4BD6C2;
    background: #F5F7FA;
    cursor: pointer;
    .text-content{
      margin: 12px 20px;
      .label{
        color: #4f5d78;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
      }
      .value{
        color: #16181a;
        font-family: Arial;
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
      }
    }
  }
}
</style>